<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
    <div id="ag-grid-demo">
        <vx-card>
            <div class="flex flex-wrap justify-between items-center">
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <h4 style="margin-left: 10px">Transporter Rates</h4>
                </div>
                <div
                    class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
                >
                    <vs-button
                        @click="refreshData"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="refresh"
                    >Refresh</vs-button>
                    <vs-button
                        :to="{ name: 'master-transporter-rate-add'} "
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="add"
                    >Add</vs-button>
                    <vs-button
                        :to="{ name: 'master-transporter-rate-view', params: {id: selectedId} }"
                        class="mb-4 md:mb-0 mr-1"
                        icon="remove_red_eye"
                        :disabled="selectedId ? false : true"
                    >View</vs-button>
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        @click="removeItem"
                        icon="delete"
                        :disabled="selectedId ? false : true"
                    >Delete</vs-button>
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        @click="showFilter = true"
                        icon="filter_list"
                    >Filter</vs-button>
                    <vs-dropdown>
                        <vs-button class="btn-drop" icon="expand_more">Spreadsheets</vs-button>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="getTemplate">Template</vs-dropdown-item>
                            <vs-dropdown-item @click="$refs.file.click()">Upload</vs-dropdown-item>
                            <input
                                type="file"
                                ref="file"
                                style="display: none"
                                v-on:change="uploadExcel"
                            />
                            <vs-dropdown-item
                                @click="exportExcel({ endpoint: 'master/transporterrates/report/exportexcel', name: 'transporter-rate', filter: filter })"
                            >Export</vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>
            <ag-grid-vue
                :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="dataApi"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                :pagination="false"
                rowSelection="single"
                @selection-changed="onSelectionChanged"
                @rowDoubleClicked="viewData"
            ></ag-grid-vue>
             <p class="text-right">
                <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</b>
            </p>
            <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>

            <vs-prompt @accept="filterData" title="Filter" :active.sync="showFilter">
                <div class="con-exemple-prompt">
                    <vs-select
                        placeholder="Client"
                        v-model="filter.client"
                        width="100%"
                        class="mt-4 mb-2 w-full"
                    >
                        <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.client_code" :text="item.client_code"/>
                    </vs-select>
                    <vs-select
                        placeholder="Transporter"
                        class="mt-4 mb-2 w-full"
                        v-model="filter.transporter"
                        width="100%"
                    >
                        <vs-select-item v-for="(item, index) in transporter.data" :key="index" :value="item.transporter_code" :text="item.transporter_code"/>
                    </vs-select>
                    <vs-select
                        placeholder="Vehicle Type"
                        class="mt-4 mb-2 w-full"
                        v-model="filter.vehicle_type"
                        width="100%"
                    >
                        <vs-select-item v-for="(item, index) in vehicle_type.data" :key="index" :value="item.vehicle_type" :text="item.vehicle_type"/>
                    </vs-select>
                    <vs-select
                        placeholder="Contract Type"
                        class="mt-4 mb-2 w-full"
                        v-model="filter.contract_type"
                        width="100%"
                    >
                        <vs-select-item v-for="(item, index) in contract_type.data" :key="index" :value="item.contract_type" :text="item.contract_type"/>
                    </vs-select>
                    <vs-select
                        placeholder="Origin"
                        class="mt-4 mb-2 w-full"
                        v-model="filter.origin"
                        width="100%"
                    >
                        <vs-select-item v-for="(item, index) in area.data" :key="index" :value="item.village" :text="item.village"/>
                    </vs-select>
                    <vs-select
                        placeholder="Destination"
                        class="mt-4 mb-2 w-full"
                        v-model="filter.destination"
                        width="100%"
                    >
                        <vs-select-item v-for="(item, index) in area.data" :key="index" :value="item.village" :text="item.village"/>
                    </vs-select>
                </div>
            </vs-prompt>
        </vx-card>
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";

export default {
    components: {
        vSelect,
        AgGridVue
    },
    data() {
        return {
            searchQuery: "",
            gridOptions: {},
            maxPageNumbers: 7,
            gridApi: null,
            dataApi: [],
            columnDefs: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            selectedId: null,
            isLoading: false,
            maxRetry: 10,
            showFilter: false,
            filter: {
                client: "",
                transporter: "",
                vehicle_type: "",
                contract_type: "",
                origin: "",
                destination: ""
            },
            clientTypeOptions: [],
            areaOptions: [],
            
            
            // Pagination
            totalPage: 0,
            // currentPage: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0,
            client: {
                data: [],
                loading: false,
                endpoint: 'master/clients',
                objectKey: 'client_code'
            },
            transporter: {
                data: [],
                loading: false,
                endpoint: 'master/transporters',
                objectKey: 'transporter_code'
            },
            vehicle_type: {
                data: [],
                loading: false,
                endpoint: 'master/vehicletypes',
                objectKey: 'vehicle_type'
            },
            contract_type: {
                data: [],
                loading: false,
                endpoint: 'master/contracttypes',
                objectKey: 'contract_type'
            },
            area: {
                data: [],
                loading: false,
                endpoint: 'master/areas',
                objectKey: 'village'
            },
        };
    },
    watch: {
        "$store.state.windowWidth"(val) {
            if (val <= 576) {
                this.maxPageNumbers = 4;
                this.gridOptions.columnApi.setColumnPinned("email", null);
            } else this.gridOptions.columnApi.setColumnPinned("email", "left");
        },

        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        }
    },
    computed: {
        paginationPageSize() {
            if (this.gridApi) return this.gridApi.paginationGetPageSize();
            else return 50;
        },
        totalPages() {
            if (this.gridApi) return this.gridApi.paginationGetTotalPages();
            else return 0;
        },
        currentPage: {
            get() {
                if (this.gridApi)
                    return this.gridApi.paginationGetCurrentPage() + 1;
                else return 1;
            },
            set(val) {
                this.gridApi.paginationGoToPage(val - 1);
            }
        }
    },
    methods: {
        updateSearchQuery(val) {
            this.gridApi.setQuickFilter(val);
        },
        onSelectionChanged() {
            var selectedRows = this.gridApi.getSelectedRows();
            var selectedRowsString = "";
            selectedRows.forEach(function(selectedRow, index) {
                if (index !== 0) {
                    selectedRowsString += ", ";
                }
                selectedRowsString += selectedRow.id;
            });
            this.selectedId = selectedRowsString;
        },
        removeItem() {
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: "Confirm",
                text: "Are you sure want to delete this Transporter Rate?",
                accept: this.acceptAlert
            });
        },
        acceptAlert() {
            this.isLoading = true;
            this.$http
                .delete(
                    "master/transporterrates/" + this.selectedId + "/destroy"
                )
                .then(res => {
                    this.$vs.notify({
                        color: "success",
                        title: "Transporter Rate deleted",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: "The selected data was successfully deleted"
                    });
                })
                .catch(error => {
                    this.$vs.notify({
                        title: "Error",
                        text: "Error.",
                        color: "danger"
                    });
                })
                .then(() => {
                    this.fetchData();
                });
        },
        refreshData() {
            this.maxRetry = 10;
            this.fetchData();
        },
        fetchData() {
            this.isLoading = true;
            this.maxRetry = this.maxRetry - 1;
            this.$http
                .post("master/transporterrates?page=" + this.currentPage)
                .then(resp => {
                    this.dataApi = resp.data.data;
                    this.totalPage = resp.data.last_page;
                    this.currentPage = this.currentPage;
                    this.dataTotal = resp.data.total;
                    this.dataFrom = resp.data.from;
                    this.dataTo = resp.data.to;
                    setTimeout(() => {
                        this.isLoading = false;
                    }, 500);
                })
                .catch(resp => {
                    if (this.maxRetry == 0) {
                        this.isLoading = false;
                        this.$vs.dialog({
                            type: "confirm",
                            color: "danger",
                            title: "Server Error",
                            text: "Try again?",
                            accept: () => {
                                this.refreshData();
                            },
                            acceptText: "Yes",
                            cancelText: "No"
                        });
                        return;
                    }
                    this.fetchData();
                });
        },
        viewData() {
            this.$router.push({
                name: "master-transporter-rate-view",
                params: {
                    id: this.selectedId
                }
            });
        },
         getTemplate() {
            this.isLoading = true;
            this.$http
                .get("master/transporterrates/report/gettemplate", {
                    responseType: "blob"
                })
                .then(response => {
                    this.isLoading = false;
                    saveAs(response.data, "transporter-rate-template.xlsx");
                });
        },
          uploadExcel() {
            let file = event.target.files[0];
            let form = new FormData();
            form.append("file", file);
            this.isLoading = true;
            this.$http
                .post("/master/transporterrates/report/importexcel", form, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                })
                .then(resp => {
                    this.isLoading = false;
                    this.fetchData();
                    this.$vs.notify({
                        color: "success",
                        title: "Upload Success",
                        text: "Upload Data Client Rate Successfully"
                    });
                })
                .catch(error => this.handleError(error))
                .then(() => (this.isLoading = false));
        },
        filterData() {
            this.isLoading = true;
            this.$http
                .post("master/transporterrates", this.filter)
                .then(resp => {
                    this.dataApi = resp.data.data;
                    setTimeout(() => {
                        this.isLoading = false;
                    }, 500);
                });
        },
        fetchDropdown() {
            this.isLoading = true
            return Promise.all([
                this.$http.post("master/clients"),
                this.$http.post("master/transporters"),
                this.$http.post("master/vehicletypes"),
                this.$http.post("master/contracttypes"),
                this.$http.post("master/areas"),
            ]).then(this.$http.spread((clients, transporters, vehicletypes, contracttypes, areas) => {
                clients.data.data.map(client => {
                    if(this.client.data.findIndex(a => a.value == client.id) === -1) {
                        this.client.data.push(client)
                    }
                })

                transporters.data.data.map(transporter => {
                    if(this.transporter.data.findIndex(a => a.value == transporter.id) === -1) {
                        this.transporter.data.push(transporter)
                    }
                })

                vehicletypes.data.data.map(vehicle_type => {
                    if(this.vehicle_type.data.findIndex(a => a.value == vehicle_type.id) === -1) {
                        this.vehicle_type.data.push(vehicle_type)
                    }
                })

                contracttypes.data.data.map(contract_type => {
                    if(this.contract_type.data.findIndex(a => a.value == contract_type.id) === -1) {
                        this.contract_type.data.push(contract_type)
                    }
                })

                areas.data.data.map(area => {
                    if(this.area.data.findIndex(a => a.value == area.id) === -1) {
                        this.area.data.push(area)
                    }
                })
            }))
        },
    },
    mounted() {
        this.fetchDropdown().then(() => this.fetchData())
        this.gridApi = this.gridOptions.api;
    },
    beforeMount() {
        this.columnDefs = [
            {
                headerName: "Rate ID",
                field: "id",
                width: 120,
                // hide: true,
                // checkboxSelection: true,
                // headerCheckboxSelectionFilteredOnly: true,
                // headerCheckboxSelection: true,
            },
            {
                headerName: "Client ID",
                field: "client_code",
                width: 120,
            },
            {
                headerName: "Transporter ID",
                field: "transporter",
                width: 120
            },
            {
                headerName: "Vehicle Type",
                field: "vehicle_type",
                width: 120
            },
            {
                headerName: "Contract type",
                field: "contract_type",
                width: 120
            },
            {
                headerName: "Origin",
                field: "origin",
                width: 120
            },
            {
                headerName: "Destination",
                field: "destination",
                width: 120
            }
        ];
        this.gridOptions.getRowHeight = function(params) {
            return 35;
        }
    }
};
</script>